import { Container, Row, Col } from "react-bootstrap";
import { CheckCircle, XCircle } from 'react-bootstrap-icons';
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion';
import TrackVisibility from 'react-on-screen';
import 'animate.css';

const fitYes = [
  "Small business owners with their name on the door",
  "Contractors, tradesmen, and owners scaling a real crew",
  "Trucking outfits, gyms, stables, and service businesses outgrowing DIY sites",
  "Niche and enthusiast brands — equestrian, automotive performance, fitness",
  "Health, wellness, and high-end personal services",
  "People who know their work better than I do — and want a partner who'll listen"
];

const fitNo = [
  "Restaurants and food & beverage",
  "Large corporations looking for an offshore vendor",
  "Non-profits asking for free or below-cost work",
  "\"We already know everything\" owners looking for a button-pusher"
];

export const ICPSection = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <section className="icp" id="who" aria-labelledby="icp-heading">
      <Container>
        <Row className="justify-content-center">
          <Col lg={11} xl={10}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={`icp-intro ${prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeIn" : "pre-reveal")}`}>
                  <h2 id="icp-heading">Built for owners. Not order-takers.</h2>
                  <p className="icp-subhead">
                    The right clients become long-term partners. The wrong ones become regret on both sides. Better to be honest up front.
                  </p>
                </div>
              )}
            </TrackVisibility>

            <Row className="icp-columns">
              <Col xs={12} md={6}>
                <TrackVisibility once>
                  {({ isVisible }) => (
                    <div className={`icp-column icp-yes ${prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeInUp" : "pre-reveal")}`}>
                      <h3>We work best with</h3>
                      <ul>
                        {fitYes.map((item, i) => (
                          <li key={i}>
                            <CheckCircle className="icp-icon icp-icon-yes" aria-hidden="true" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </TrackVisibility>
              </Col>
              <Col xs={12} md={6}>
                <TrackVisibility once>
                  {({ isVisible }) => (
                    <div className={`icp-column icp-no ${prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeInUp" : "pre-reveal")}`} style={{ animationDelay: '120ms' }}>
                      <h3>We're not a fit for</h3>
                      <ul>
                        {fitNo.map((item, i) => (
                          <li key={i}>
                            <XCircle className="icp-icon icp-icon-no" aria-hidden="true" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </TrackVisibility>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
